var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitVersions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1765865496958,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 956,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1004.72704 466.4L557.62304 19.328a65.952 65.952 0 0 0-93.28 0L360.47104 123.2l78.176 78.176a96 96 0 0 1 128 128l127.968 127.968a96 96 0 1 1-45.248 45.248l-127.968-127.968a88.832 88.832 0 0 1-9.376 3.872v266.976a96 96 0 1 1-64 0v-266.976a96 96 0 0 1-54.624-131.904L315.22304 168.416 19.31904 464.288a65.952 65.952 0 0 0 0 93.28l447.136 447.072a65.952 65.952 0 0 0 93.28 0l444.992-444.992a65.952 65.952 0 0 0 0-93.28z",
    "p-id": 957,
    fill: "#2f8f79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitVersions);
export default __webpack_public_path__ + "static/media/git-versions.1712b767caa5dcfb64d1452ad82365a9.svg";
export { ForwardRef as ReactComponent };